import styled from '@emotion/styled/macro';
import { BaseButton, Variables } from '../../../base';
import {
    CdCard,
    CdFactCell,
    CdFactLabel,
    CdFactsGrid as SharedCdFactsGrid,
    CdFactValue,
    CdPanel,
    CdSectionCard,
} from './timeline-detail-card.styles';

export { CdCard, CdFactCell, CdFactLabel, CdFactValue, CdPanel, CdSectionCard };

export const CdFactsGrid = styled(SharedCdFactsGrid)`
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px 28px;
    margin-top: 16px;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

const monoFont = 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace';

export const CdHeaderRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 14px;
    flex-wrap: wrap;
`;

export const CdIconWrap = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: ${Variables.ThemeLight.NeutralMild1};
    border: 1px solid ${Variables.ThemeLight.Border2};
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
`;

export const CdHeaderMain = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    flex: 1;
`;

export const CdTitle = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const CdSubtitle = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 14px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMedium};
`;

export const CdMuted = styled.span`
    color: ${Variables.ThemeLight.TextMild};
`;

export const CdTypePill = styled.span`
    font-family: ${monoFont};
    font-size: 12px;
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextStrong};
    background: ${Variables.ThemeLight.NeutralMild1};
    border: 1px solid ${Variables.ThemeLight.Border2};
    padding: 2px 7px;
    border-radius: 4px;
    align-self: flex-start;
`;

export const CdTreeCard = styled(CdSectionCard)`
    padding: 16px 18px 18px;
`;

export const CdTreeWrap = styled.div`
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 8px;
    overflow: hidden;
`;

export const CdTreeToolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    background: ${Variables.ThemeLight.Background1};
    border-bottom: 1px solid ${Variables.ThemeLight.Border2};
`;

export const CdTreeTitle = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const CdTreeActions = styled.div`
    margin-left: auto;
    display: inline-flex;
    gap: 6px;
`;

export const CdMiniButton = styled(BaseButton)`
    height: 26px;
    padding: 0 10px;
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 6px;
    background: ${Variables.ThemeLight.Background2};
    color: ${Variables.ThemeLight.TextMedium};
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    cursor: pointer;
`;

export const CdTreeScroll = styled.div<{ $embedded?: boolean }>`
    overflow: auto;
    max-height: ${({ $embedded }) => ($embedded ? '460px' : 'none')};
    padding: 8px 6px;
    background: ${Variables.ThemeLight.Background3};
`;

export const CdTreeBody = styled.div`
    min-width: max-content;
`;

export const CdTreeLine = styled.div<{ $clickable?: boolean }>`
    display: flex;
    align-items: center;
    height: 22px;
    line-height: 22px;
    border-radius: 4px;
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

    &:hover {
        background: ${({ $clickable }) => ($clickable ? Variables.ThemeLight.NeutralMild1 : 'transparent')};
    }
`;

export const CdTreeLeaf = styled.div`
    display: flex;
    height: 22px;
    line-height: 22px;
`;

export const CdTreeToggle = styled.span`
    flex: none;
    width: 16px;
    color: ${Variables.ThemeLight.TextMild};
`;

export const CdTreeSpacer = styled.span`
    flex: none;
    width: 16px;
`;

export const CdTreeCode = styled.code<{ $added?: boolean }>`
    font-family: ${monoFont};
    font-size: 12px;
    white-space: pre;
    font-weight: ${({ $added }) => ($added ? 600 : 400)};
`;

export const CdJsonPlain = styled.span`
    color: ${Variables.ThemeLight.TextMedium};
`;

export const CdJsonKey = styled.span`
    color: ${Variables.ThemeLight.TextMild};
`;

export const CdJsonColon = styled.span`
    color: ${Variables.ThemeLight.TextXMild};
`;

export const CdJsonString = styled.span`
    color: ${Variables.ThemeLight.AttentionConstant6};
`;

export const CdJsonPrimitive = styled.span`
    color: ${Variables.ThemeLight.PrimaryConstant6};
`;

export const CdJsonMuted = styled.span`
    color: ${Variables.ThemeLight.TextXMild};
`;
